import { Injectable } from '@angular/core';
import { Mortgage } from '@app/core/stingray-api/models';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class MortgageService {

  private get mortgage(): Mortgage {
    return this.mortgage$.value;
  }

  private mortgage$: BehaviorSubject<Mortgage> = new BehaviorSubject<Mortgage>(null);
  private mortgageIsUpdating$: BehaviorSubject<boolean>;

  private updateMortgageBuildings$: Subject<void>;
  private updateMortgageLoanParts$: Subject<void>;

  constructor() {
  }

  getMortgage(): Observable<Mortgage> {
    return this.mortgage$.asObservable();
  }

  setMortgage(mortgage: Mortgage) {
    if (this.mortgage === null || this.mortgage.id !== mortgage.id) {
      this.init();
    }

    this.mortgage$ = new BehaviorSubject<Mortgage>(mortgage);
  }

  updateMortgage(mortgage: Mortgage) {
    this.mortgage$.next(mortgage);
  }

  getMortgageIsUpdating(): Observable<boolean> {
    return this.mortgageIsUpdating$.asObservable();
  }

  setMortgageIsUpdating(mortgageIsUpdating: boolean) {
    this.mortgageIsUpdating$.next(mortgageIsUpdating);
  }

  getUpdateMortgageBuildings(): Observable<void> {
    return this.updateMortgageBuildings$.asObservable();
  }

  setUpdateMortgageBuildings() {
    this.updateMortgageBuildings$.next();
  }

  getUpdateMortgageLoanParts(): Observable<void> {
    return this.updateMortgageLoanParts$.asObservable();
  }

  setUpdateMortgageLoanParts() {
    this.updateMortgageLoanParts$.next();
  }


  init() {
    this.clearCache();

    this.mortgageIsUpdating$ = new BehaviorSubject<boolean>(false);
    this.updateMortgageBuildings$ = new Subject();
    this.updateMortgageLoanParts$ = new Subject();
  }

  /**
   * Clear the mortgage fields that are cached
   */
  private clearCache() {
  }

}
